import { render, staticRenderFns } from "./VerifySignup.vue?vue&type=template&id=5f32e361"
import script from "./VerifySignup.vue?vue&type=script&lang=js"
export * from "./VerifySignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports